var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M4.77251 14.9177C4.59224 15.0017 4.45274 15.154 4.38471 15.3409C4.31668 15.5278 4.32568 15.7341 4.40975 15.9143C4.49381 16.0946 4.64605 16.2341 4.83296 16.3022C5.01988 16.3702 5.22617 16.3612 5.40644 16.2771L4.77251 14.9177ZM5.40644 16.2771L19.9074 9.51522L19.2734 8.15576L4.77251 14.9177L5.40644 16.2771Z",
    fill: "#3B3B58"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6883 16.8091L19.5904 8.83555L11.6168 5.93341",
    stroke: "#3B3B58",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.2716be84dbe8d7ba49d4450d437d3926.svg";
export { ForwardRef as ReactComponent };